import BadgeNext from "ds/components/BadgeNext";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import IconEmphasized from "ds/components/IconEmphasized";
import TileTitle from "ds/components/Tile/Title";
import TileWrapper from "ds/components/Tile/Wrapper";
import Tooltip from "ds/components/Tooltip";
import { IconComponent } from "types/Icon";

import styles from "./styles.module.css";

type LlmSelectorTileProps = {
  icon: IconComponent;
  onSelect: () => void;
  name: string;
  isSelected: boolean;
  disabled?: boolean;
  disabledReason?: string;
};

const LlmSelectorTile = ({
  icon,
  onSelect,
  name,
  isSelected,
  disabled = false,
  disabledReason,
}: LlmSelectorTileProps) => {
  return (
    <Tooltip
      active={!!disabledReason}
      on={(tooltipProps) => (
        <TileWrapper
          {...tooltipProps}
          className={styles.llmSelectorTileWrapper}
          justify="between"
          align="center"
          disabled={disabled}
        >
          <Box gap="large" align="center">
            <IconEmphasized icon={icon} variant="secondary" />
            <TileTitle>{name}</TileTitle>
            {isSelected && <BadgeNext variant="green" type="strong" text="Selected" />}
          </Box>
          {!isSelected && (
            <Button variant="secondary" onPress={onSelect} disabled={disabled}>
              Enable
            </Button>
          )}
        </TileWrapper>
      )}
      placement="top"
    >
      {disabledReason}
    </Tooltip>
  );
};

export default LlmSelectorTile;
